import Vue3linkify from 'vue-3-linkify'

export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.vueApp.use(Vue3linkify)
})
